import React from 'react';
import { twMerge } from 'tailwind-merge';

const PageContainer = ({ children, className }) => {
  return <div className={twMerge('flex flex-col gap-4', className)}>{children}</div>;
};

export default PageContainer;
